import {Box, Chip, Grid} from "@mui/material";
import {Filter, Select} from "@variocube/app-ui";
import React from "react";
import {USER_ROLES, UserFilter} from "../../api";
import {useLocalization} from "../../i18n";

interface UserFilterBarProps {
	value: UserFilter;
	onChange: (value: UserFilter) => void;
}

export function UserFilterBar({value, onChange}: UserFilterBarProps) {
	const {s, t} = useLocalization();

	return (
		<Filter
			labels={s("filter")}
			label={t("filter.title")}
			onClear={() => onChange({})}
			enableSearch
			onSearch={search => onChange({...value, search})}
			active={[
				value.role && (
					<Chip
						label={`${t("users.role")}: ${t(`users.roles.${value.role}`)}`}
						onDelete={() => onChange({...value, role: undefined})}
					/>
				),
				value.search && (
					<Chip
						label={`${value.search}`}
						onDelete={() => onChange({...value, search: undefined})}
					/>
				)
			]}
		>
			<Box p={2}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={4}>
						<Select
							label={t("users.role")}
							fullWidth
							options={USER_ROLES}
							value={value.role}
							onChange={role => onChange({...value, role})}
							renderLabel={s("users.roles")}
						/>
					</Grid>
				</Grid>
			</Box>
		</Filter>
	);
}
